<pm-breadcrumbs
  [items]="breadcrumbs()"
  (breadcrumbClick)="handleBreadcrumbClick($event)"
/>
